const StakingActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  OPEN_MODAL: 'open_modal',
  UPDATE_SHOW_REWARD_INFO: 'update_show_reward_info',
  UPDATE_MAIN_STAKING_WALLET: 'update_main_staking_wallet',
  UPDATE_WALLETS: 'update_wallets',
};

const StakingReducer = (state, action) => {
  switch (action.type) {
    case StakingActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case StakingActionTypes.OPEN_MODAL:
      return { ...state, [`${action.payload.screen}ModalOpened`]: action.payload.value };
    case StakingActionTypes.UPDATE_SHOW_REWARD_INFO:
      return {
        ...state,
        showRewardInfo: action.payload,
      };

    case StakingActionTypes.UPDATE_MAIN_STAKING_WALLET:
      return { ...state, mainStakingWallet: action.payload };
    case StakingActionTypes.UPDATE_WALLETS:
      return { ...state, wallets: action.payload };
    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: StakingActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const toggleModal = (dispatch) => (screen, value) =>
  dispatch({ type: StakingActionTypes.OPEN_MODAL, payload: { screen, value } });

const updateMainStakingWallet = (dispatch) => (wallet) =>
  dispatch({ type: StakingActionTypes.UPDATE_MAIN_STAKING_WALLET, payload: wallet });

const updateWallets = (dispatch) => (wallets) =>
  dispatch({ type: StakingActionTypes.UPDATE_WALLETS, payload: wallets });

const updateShowRewardInfo = (dispatch) => (show) =>
  dispatch({
    type: StakingActionTypes.UPDATE_SHOW_REWARD_INFO,
    payload: show,
  });

// eslint-disable-next-line import/prefer-default-export
export const staking = {
  StakingReducer,
  actions: {
    toggleModal,
    openScreen,
    updateMainStakingWallet,
    updateShowRewardInfo,
    updateWallets,
  },
};
